"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var form_primary_action_button_1 = require("./form_primary_action_button");
function OnboardingFormSaveButton(_a) {
    var isSaving = _a.isSaving, isDisabled = _a.isDisabled, props = tslib_1.__rest(_a, ["isSaving", "isDisabled"]);
    var disabled = isSaving || isDisabled;
    var buttonText = isSaving ? // show 'save' when disabled
        I18n.t('discovery.coreOnboarding.processing') :
        I18n.t('discovery.coreOnboarding.save');
    return (React.createElement(form_primary_action_button_1.default, tslib_1.__assign({ disabled: disabled, buttonText: buttonText }, props)));
}
exports.default = OnboardingFormSaveButton;
//# sourceMappingURL=onboarding_form_save_button.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/onboarding/onboarding_form_save_button.js
// module id = pWAf
// module chunks = 20 21